import { forwardRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { IconPlusCircledFilled } from 'src/assets/icons/IconPlusCircledFilled';
import { CustomButtonBase } from 'src/components/CustomButtonBase';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

export const AddInfoButton = forwardRef(({ className, onClick, disabled, ...restProps }, ref) => {
  const styles = useStyles();

  return (
    <CustomButtonBase
      className={cx(styles.root, className)}
      ref={ref}
      onClick={onClick}
      disabled={disabled}
      {...restProps}
    >
      <IconPlusCircledFilled className={styles.icon} />
      <CustomTypography variant={TYPOGRAPHY_VARIANT.medium12}>Add files</CustomTypography>
    </CustomButtonBase>
  );
});

AddInfoButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
AddInfoButton.defaultProps = {
  className: null,
  disabled: false,
};
